import type { AdScore } from '@/types'
import { cn } from '@/lib/cn'

const labels: Record<AdScore, string> = {
  scale: 'SCALE',
  watch: 'WATCH',
  pause: 'PAUSE',
}

const colors: Record<AdScore, string> = {
  scale: 'bg-jarvis-green/10 text-jarvis-green border-jarvis-green/20',
  watch: 'bg-jarvis-amber/10 text-jarvis-amber border-jarvis-amber/20',
  pause: 'bg-jarvis-red/10 text-jarvis-red border-jarvis-red/20',
}

const icons: Record<AdScore, string> = {
  scale: '🟢',
  watch: '🟡',
  pause: '🔴',
}

interface ScoreBadgeProps {
  score: AdScore
  showIcon?: boolean
  className?: string
}

export function ScoreBadge({ score, showIcon = true, className }: ScoreBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-xs font-semibold tracking-wider',
        colors[score],
        className,
      )}
    >
      {showIcon && <span aria-hidden>{icons[score]}</span>}
      {labels[score]}
    </span>
  )
}
